// ============================================
// Creator Module - Search & Sort (ES6)
// ============================================

import { escapeHtml } from '../utils.js';
import {
  getCurrentCreations,
  getCurrentSort, setCurrentSort,
  getSearchTimeout, setSearchTimeout
} from './state.js';
import { renderCreationItem, renderCreationsList } from './list.js';

// ============================================
// 검색 기능
// ============================================

export function openSearch() {
  const modal = document.getElementById('creatorSearchModal');
  if (modal) {
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    const input = document.getElementById('creatorSearchInput');
    if (input) {
      input.value = '';
      input.focus();
    }
    renderSearchResults([]);
    // z-index 동적 관리
    if (window.ModalManager) {
      window.ModalManager.push('creatorSearchModal');
    }
  }
}

export function closeSearch() {
  const modal = document.getElementById('creatorSearchModal');
  if (modal) {
    modal.style.display = 'none';
    document.body.style.overflow = '';
    // z-index 스택에서 제거
    if (window.ModalManager) {
      window.ModalManager.remove('creatorSearchModal');
    }
  }
}

export function handleSearch(query) {
  const clearBtn = document.querySelector('.creator-search-clear');
  if (clearBtn) {
    clearBtn.style.display = query ? 'flex' : 'none';
  }

  const currentTimeout = getSearchTimeout();
  if (currentTimeout) {
    clearTimeout(currentTimeout);
  }

  const timeout = setTimeout(() => {
    if (!query.trim()) {
      renderSearchResults([]);
      return;
    }

    const results = getCurrentCreations().filter(creation => {
      const searchText = query.toLowerCase();
      const title = (creation.title || creation.characterName || '').toLowerCase();
      const shortIntro = (creation.shortIntro || '').toLowerCase();
      const tags = (creation.tags || []).join(' ').toLowerCase();
      return title.includes(searchText) || shortIntro.includes(searchText) || tags.includes(searchText);
    });

    renderSearchResults(results, query);
  }, 200);

  setSearchTimeout(timeout);
}

export function clearSearch() {
  const input = document.getElementById('creatorSearchInput');
  if (input) {
    input.value = '';
    input.focus();
  }
  renderSearchResults([]);
}

function renderSearchResults(results, query = '') {
  const container = document.getElementById('creatorSearchResults');
  if (!container) return;

  if (!query.trim()) {
    container.innerHTML = `<div class="search-placeholder">검색어를 입력하세요</div>`;
    return;
  }

  if (results.length === 0) {
    container.innerHTML = `<div class="search-placeholder">검색 결과가 없습니다</div>`;
    return;
  }

  container.innerHTML = results.map(creation => renderCreationItem(creation)).join('');
}

// ============================================
// 정렬 모달
// ============================================

export function openSortModal() {
  const modal = document.getElementById('creatorSortModal');
  if (modal) {
    modal.style.display = 'flex';
    // 현재 정렬 상태 반영
    const currentSort = getCurrentSort();
    document.querySelectorAll('.creator-sort-option').forEach(btn => {
      btn.classList.toggle('active', btn.dataset.sort === currentSort);
    });
    // ModalManager에 push
    if (window.ModalManager) {
      window.ModalManager.push('creatorSortModal');
    }
  }
}

export function closeSortModal() {
  const modal = document.getElementById('creatorSortModal');
  if (modal) {
    modal.style.display = 'none';
  }
  // ModalManager에서 제거
  if (window.ModalManager) {
    window.ModalManager.remove('creatorSortModal', true);
  }
}

export function setSort(sortType) {
  setCurrentSort(sortType);

  // 라벨 업데이트
  const label = document.getElementById('creatorSortLabel');
  if (label) {
    label.textContent = sortType === 'plays' ? '대화량순' : '최신순';
  }

  // 모달 닫기
  closeSortModal();

  // 목록 다시 렌더링
  renderCreationsList();
}
